import { TranslateModule } from '@ngx-translate/core';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DropdownModule as PrimeNGDropdownModule } from 'primeng/dropdown';
import { FormsModule } from '@angular/forms';
import { DropdownSettingDirective } from './dropdown-setting.directive';

@NgModule({
  declarations: [DropdownSettingDirective],
  imports: [CommonModule, FormsModule, TranslateModule, PrimeNGDropdownModule],
  exports: [DropdownSettingDirective],
})
export class DropdownModule {}
